// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Eo-z","badgeLink":"Fo-z","category":"Go-z"};